export default __webpack_public_path__ + "static/schema-a4de3de27a0da81b0717caac212b6a67.png";